/**
 * „Rückgängig"-Toast: zeigt `message` mit einer Aktion, die bei Klick die gepufferte Inverse-Op
 * ausführt — Grundlage für „still + Undo" (Drag-to-Papierkorb, Cross-Category-Reclassify). Die
 * Inverse läuft höchstens einmal; scheitert sie, erscheint ein Fehler-Toast. Die Anzeigedauer ist
 * länger als bei Standard-Toasts, damit das Undo-Fenster reicht.
 */
import { toast } from 'sonner';

export interface UndoToastOptions {
  /** Bestätigung nach erfolgreicher Rücknahme (z. B. „Wiederhergestellt."). */
  undoneMessage?: string;
  /** Meldung, falls die Inverse-Op scheitert (Default „Rückgängig fehlgeschlagen."). */
  errorMessage?: string;
  /** Anzeigedauer in ms (Default 6000 — länger als Standard-Toasts fürs Undo-Fenster). */
  duration?: number;
}

export function showUndoToast(
  message: string,
  undo: () => Promise<void>,
  options: UndoToastOptions = {},
): void {
  const { undoneMessage, errorMessage = 'Rückgängig fehlgeschlagen.', duration = 6000 } = options;
  let triggered = false;
  toast.success(message, {
    duration,
    action: {
      label: 'Rückgängig',
      onClick: () => {
        // Aktion nur einmal auslösen — der laufende Undo darf nicht doppelt feuern.
        if (triggered) return;
        triggered = true;
        void undo()
          .then(() => {
            if (undoneMessage) toast.success(undoneMessage);
          })
          .catch(() => toast.error(errorMessage));
      },
    },
  });
}
